import React from 'react';
import { ColumnType } from '@base/ui/components/dataTable';
import { Tournament } from '@base/features/tournaments/model/interfaces';

export const tourStatisticsCols: ColumnType<Tournament>[] = [
  {
    title: 'date',
    dataIndex: 'StartTime',
    render: (statistics) => <span>{statistics.StartTime}</span>,
  },
  {
    title: 'winner',
    dataIndex: 'FirstPlace',
    render: (statistics) => <span>{statistics.FirstPlace}</span>,
  },
  {
    title: 'second_place',
    dataIndex: 'SecondPlace',
    render: (statistics) => <span>{statistics.SecondPlace}</span>,
  },
  {
    title: 'entry_fee',
    dataIndex: 'EntryFee',
    render: (statistics) => <span>{statistics.EntryFee}</span>,
  },
  {
    title: 'prize_won',
    dataIndex: 'Prize',
    render: (statistics) => <span>{statistics.Prize}</span>,
  },
];
